import mirrorCreator from 'mirror-creator';

export default mirrorCreator([
  'SNAPSELL_GO_TO_NEXT_STEP',
  'SNAPSELL_GO_TO_PREVIOUS_STEP',
  'SNAPSELL_STEP_CHANGE_REJECTED',
  'SNAPSELL_GO_TO_STEP',
]);



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/constants/snapSellWizardConstants.js